import { Injectable } from "@angular/core";
import { ClaimsRedirectValues } from "../enums/claims-redirect-values";
import { ClaimsType } from "../enums/claims.type";

export interface Claims {
  claimsType: ClaimsType;
  claimsRedirectValue: ClaimsRedirectValues;
  text: string;
  logo: string;
}
@Injectable({
  providedIn: "root",
})
export class ClaimsTypeService {
  claims: Claims[] = [
    // {
    //   claimsType: ClaimsType.CED,
    //   claimsRedirectValue: ClaimsRedirectValues.CEDDeclare,
    //   text: "serviceOfferings.declareIncident",
    //   logo: "pi pi-exclamation-circle",
    // },
    // {
    //   claimsType: ClaimsType.CED,
    //   claimsRedirectValue: ClaimsRedirectValues.CEDFollow,
    //   text: "serviceOfferings.followIncident",
    //   logo: "pi pi-eye",
    // },
    {
      claimsType: ClaimsType.SFPJ,
      claimsRedirectValue: ClaimsRedirectValues.SFPJConsultation,
      text: "serviceOfferings.legalQuestion",
      logo: "pi pi-building-columns",
    },
    {
      claimsType: ClaimsType.SFPJ,
      claimsRedirectValue: ClaimsRedirectValues.SFPJDeclarationLitiges,
      text: "serviceOfferings.declareDispute",
      logo: "pi pi-wave-pulse",
    },
    {
      claimsType: ClaimsType.SFPJ,
      claimsRedirectValue: ClaimsRedirectValues.SFPJLitiges,
      text: "serviceOfferings.consultDispute",
      logo: "pi pi-eye",
    },
    {
      claimsType: ClaimsType.SFPJ,
      claimsRedirectValue: ClaimsRedirectValues.SFPJContracts,
      text: "serviceOfferings.accessLegalInfo",
      logo: "pi pi-eye",
    },
    // {
    //   claimsType: ClaimsType.RMA,
    //   claimsRedirectValue: ClaimsRedirectValues.RMAHealthSheet,
    //   text: "serviceOfferings.downloadHealthSheet",
    //   icon: "pi pi-wave-pulse",
    // },
    // TODO: Uncomment when the sinister flow is ready
    // {
    //   claimsType: ClaimsType.RMA,
    //   claimsRedirectValue: ClaimsRedirectValues.RMADeathAttestations,
    //   text: "serviceOfferings.downloadDeathAttestation",
    //   icon: "pi pi-download",
    // },
    // {
    //   claimsType: ClaimsType.RMA,
    //   claimsRedirectValue: ClaimsRedirectValues.RMASinister,
    //   text: "serviceOfferings.declareSAIncident",
    //   logo: "assets/common/icons/animal.svg",
    // },
    // {
    //   claimsType: ClaimsType.RMA,
    //   claimsRedirectValue: ClaimsRedirectValues.RMASinisterFollow,
    //   text: "serviceOfferings.followSASinister",
    //   icon: "pi pi-eye",
    // },
    // FOR NOW WE LET THIS UNTIL THE SINISTER FLOW IS READY
    // {
    //   claimsType: ClaimsType.ALTIMA,
    //   claimsRedirectValue: ClaimsRedirectValues.ALTIMADeclaration,
    //   text: "serviceOfferings.declareIncident",
    //   logo: "pi pi-exclamation-circle",
    // },
    // {
    //   claimsType: ClaimsType.ALTIMA,
    //   claimsRedirectValue: ClaimsRedirectValues.ALTIMAFollow,
    //   text: "serviceOfferings.followIncident",
    //   logo: "pi pi-eye",
    // },
  ];

  getClaims() {
    return this.claims;
  }
}
